import React from 'react';
import Nav from '../../../components/specific/Navigation';
import Filter from '../../../components/specific/Contrato/Filter';
import { ModalAgregarContrato } from '../../../components/specific/Contrato/Modales/agregarContrato';
import TableContrato from '../../../components/specific/Contrato/Table';
import { Toaster } from 'react-hot-toast';
import LoadingTables from '../../../components/global/LoadingTables';
import { store } from '../../../store';
import { setSelContratoInit } from '../../../actions';
import PageHeading from '../../../components/global/PageHeading';
import { ButtonTable } from '../../../components/global/Styles/buttons';
import { TitlesTables } from '../../../components/global/Styles/titles';

const ViewContrato = (props) => {
  const { modalAgregarContrato, setModalAgregarContrato } = props.modal;
  const { createContrato, validate, updateContrato } = props.endPoint;
  const { getRoles } = props;
  const { loadingTables } = props.actions;

  const handleClick = () => {
    store.dispatch(setSelContratoInit());
    setModalAgregarContrato(true);
  };

  return (
    <div className="flex max-h-screen min-h-screen flex-col overflow-hidden ">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'bg-gray-500 p-2 rounded-md text-white font-bold text-sm ',
        }}
      />

      <div className="flex flex-grow flex-col overflow-hidden ">
        <div className="m-2 flex flex-grow flex-col overflow-hidden   ">
          <div className="flex ">
            <TitlesTables>CLIENTE CONTRATOS / MODO DE OPERACIÓN</TitlesTables>
            <div className="flex-auto"></div>

            <ButtonTable onClick={handleClick}>Agregar</ButtonTable>
          </div>

          {loadingTables && <LoadingTables />}
          <TableContrato
            data={props.data}
            actions={props.actions}
            endPoint={props.endPoint}
          />
        </div>
      </div>

      {modalAgregarContrato ? (
        <ModalAgregarContrato
          endPoint={{ createContrato, validate, updateContrato }}
          setModalAgregarContrato={setModalAgregarContrato}
          getRoles={getRoles}
        />
      ) : null}
    </div>
  );
};

export default ViewContrato;
